export default "__VITE_ASSET__D$ueVedm__"